import React, { useState } from "react";
import adminImage from "../../../assets/images/me.jpg";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../../../utils/custom-loader";
import useUserProfile from "../../../customHooks/useUserProfile";
import BiLogo from "../../IconsPack/BiLogo";

interface ProfileProps {
  title: string;
  description: string;
  subtitle: string;
  userProfile: {
    name: string;
    imageUrl: string;
  };
  onSubmit: (event: React.FormEvent) => void;
  onUploadDoc: (
    event: React.ChangeEvent<HTMLInputElement>,
    field: string
  ) => void;
  basicTable: {
    columns: {
      Header?: string;
      accessor: string;
      name?: string;
    }[];
    data: {
      [key: string]: React.ReactNode;
    }[];
  };
  contactTable: {
    columns: {
      Header?: string;
      accessor: string;
      name?: string;
    }[];
    data: {
      [key: string]: React.ReactNode;
    }[];
  };
  passwordTab: {
    columns: {
      Header?: string;
      accessor: string;
      name?: string;
    }[];
    data: {
      [key: string]: React.ReactNode;
    }[];
  };
  paymentTable: {
    columns: {
      Header?: string;
      accessor: string;
      name?: string;
    }[];
    data: {
      [key: string]: React.ReactNode;
    }[];
  };
  onEditBasicTable: () => void;
  onEditContactTable: () => void;
  onEditPasswordTab: () => void;
  onEditPaymentTable: () => void;
}

const Profile: React.FC<ProfileProps> = ({
  description,
  subtitle,
  onSubmit,
  onUploadDoc,
  basicTable,
  contactTable,
  passwordTab,
  paymentTable,
  onEditBasicTable,
  onEditContactTable,
  onEditPasswordTab,
  onEditPaymentTable,
}) => {
  const [selectedNavItem, setSelectedNavItem] = useState(1);
  //   const { userProfile, isLoading, error } = useUserProfile(); // Unconditionally call the hook

  //   // Handle loading and error states
  //   if (isLoading) {
  //     return <CustomLoader isLoading={true} />;

  //   }

  //   if (error) {
  //     return <div>Error: {error.message}</div>;
  //   }

  const navigate = useNavigate();

  return (
    <div className="flex h-screen">
      
      <div className="flex-1 bg-[#F3F6FF]">
        {/* Page Content */}
        <div className="bg-[#F3F6FF] pl-[350px] pr-[60px] py-20 pt-[120px] items-center justify-center">

          <div className="bg-white shadow rounded-[8px] py-[10px] px-[50px] mb-[20px] flex items-center">
            <div className="flex-1">
              <h2 className="text-[24px] font-ubuntu font-[500]">
                {description}
              </h2>
              <p className="text-black text-[14px] font-ubuntu font-[400]">
                {subtitle}
              </p>
            </div>
            <div className="flex flex-col items-center ml-8 py-[15px]">
              <div className="w-[45px] h-[45px] rounded-full overflow-hidden">
                <img
                  src={adminImage}
                  alt="Application Image"
                  className="w-[50px] h-[50px] object-cover"
                />
              </div>
              <p className="text-[10px] font-ubuntu font-[400]">BiU010010112</p>
            </div>
          </div>

          {/* Basic Info Table */}
          <div className="bg-white shadow rounded-[8px] py-[20px] px-[60px] mt-8">
            <div className="w-full flex flex-row justify-between items-center mb-6">
              <h2 className="text-[24px] font-ubuntu font-[600] mb-[2px]">
                Basic Info
              </h2>
              <button onClick={onEditBasicTable} className="text-blue-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1.5em"
                  height="1.5em"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="#0073C0"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m14.304 4.844l2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565l6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
                  />
                </svg>
              </button>
            </div>
            <table className="w-full">
              <thead>
                <tr>
                  {basicTable.columns.map((column, index) => (
                    <th key={index} className="text-left">
                      {column.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {basicTable.data.map((row, index) => (
                  <React.Fragment key={index}>
                    <tr className="flex items-center cursor-pointer">
                      <td className="flex-1 text-left">
                        {row[basicTable.columns[0].accessor]}
                      </td>
                      <td className="flex-1 text-center">
                        {row[basicTable.columns[1].accessor]}
                      </td>
                    </tr>
                    {index !== basicTable.data.length - 1 && (
                      <tr>
                        <td colSpan={4}>
                          <hr className="border-[1px] border-gray-200 my-3" />
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>

          {/* Contact Info Table */}
          <div className="bg-white shadow rounded-[8px] py-[20px] px-[60px] mt-8">
            <div className="w-full flex flex-row justify-between items-center mb-6">
              <h2 className="text-[24px] font-ubuntu font-[600] mb-[2px]">
                Contact Info
              </h2>
              <button onClick={onEditContactTable} className="text-blue-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1.5em"
                  height="1.5em"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="#0073C0"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m14.304 4.844l2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565l6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
                  />
                </svg>
              </button>
            </div>
            <table className="w-full">
              <thead>
                <tr>
                  {contactTable.columns.map((column, index) => (
                    <th key={index} className="text-left">
                      {column.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {contactTable.data.map((row, index) => (
                  <React.Fragment key={index}>
                    <tr className="flex items-center cursor-pointer">
                      <td className="flex-1 text-left">
                        {row[contactTable.columns[0].accessor]}
                      </td>
                      <td className="flex-1 text-center">
                        {row[contactTable.columns[1].accessor]}
                      </td>
                    </tr>
                    {index !== contactTable.data.length - 1 && (
                      <tr>
                        <td colSpan={4}>
                          <hr className="border-[1px] border-gray-200 my-3" />
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>

          {/* Password Tab */}
          <div className="bg-white shadow rounded-[8px] py-[20px] px-[60px] mt-8">
            <div className="w-full flex flex-row justify-between items-center mb-6">
              <h2 className="text-[24px] font-ubuntu font-[600] mb-[2px]">
                Password
              </h2>
              <button onClick={onEditPasswordTab} className="text-blue-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1.5em"
                  height="1.5em"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="#0073C0"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m14.304 4.844l2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565l6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
                  />
                </svg>
              </button>
            </div>
            <table className="w-full">
              <thead>
                <tr>
                  {passwordTab.columns.map((column, index) => (
                    <th key={index} className="text-left">
                      {column.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {passwordTab.data.map((row, index) => (
                  <React.Fragment key={index}>
                    <tr className="flex items-center cursor-pointer">
                      <td className="flex-1 text-left">
                        {row[passwordTab.columns[0].accessor]}
                      </td>
                      <td className="flex-1 text-center">
                        {row[passwordTab.columns[1].accessor]}
                      </td>
                    </tr>
                    {index !== passwordTab.data.length - 1 && (
                      <tr>
                        <td colSpan={4}>
                          <hr className="border-[1px] border-gray-200 my-3" />
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>

          {/* Payment Info Table */}
          <div className="bg-white shadow rounded-[8px] py-[20px] px-[60px] mt-8">
            <div className="w-full flex flex-row justify-between items-center mb-6">
              <h2 className="text-[24px] font-ubuntu font-[600] mb-[2px]">
                Payment Info
              </h2>
              <button onClick={onEditPaymentTable} className="text-blue-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1.5em"
                  height="1.5em"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="#0073C0"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m14.304 4.844l2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565l6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
                  />
                </svg>
              </button>
            </div>
            <table className="w-full">
              <thead>
                <tr>
                  {paymentTable.columns.map((column, index) => (
                    <th key={index} className="text-left">
                      {column.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paymentTable.data.map((row, index) => (
                  <React.Fragment key={index}>
                    <tr className="flex items-center cursor-pointer">
                      <td className="flex-1 text-left">
                        {row[paymentTable.columns[0].accessor]}
                      </td>
                      <td className="flex-1 text-center">
                        {row[paymentTable.columns[1].accessor]}
                      </td>
                    </tr>
                    {index !== paymentTable.data.length - 1 && (
                      <tr>
                        <td colSpan={4}>
                          <hr className="border-[1px] border-gray-200 my-3" />
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
